const breakpoints = {
	'min': 280,
	'mobile-xs': 320,
	'mobile-sm': 360,
	'mobile': 375,
	'mobile-md': 384,
	'mobile-lg': 400,
	'mobile-xl': 480,
	'tablet-xs': 540,
	'tablet-sm': 600,
	'tablet': 768,
	'tablet-md': 900,
	'tablet-lg': 1024,
	'desktop-sm': 1180,
	'desktop': 1440,
	'desktop-md': 1600,
	'desktop-lg': 1920,
	'max': 1920,
	'wide': 2700,
	'design-mobile': 393,
	'design-tablet': 800,
	'design-desktop': 1680,
}

export {
    breakpoints,
}
